import { render } from "./KlinePic.vue?vue&type=template&id=2d47966c&scoped=true"
import script from "./KlinePic.vue?vue&type=script&lang=js"
export * from "./KlinePic.vue?vue&type=script&lang=js"

import "./KlinePic.vue?vue&type=style&index=0&id=2d47966c&lang=less&scoped=true"

import exportComponent from "/Users/apple/Desktop/project/exchange/matcha-topcredit/Bitvavo/20250313/exchange_user_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d47966c"]])

export default __exports__